export const unique = (arr: any[]) => {
    return arr.filter(function (elem, index, self) {
        return index === self.indexOf(elem)
    })
}

export const mapBlockedDays = (arr: any[]) => {
    const filterArr: any[] = arr.filter((i: any) => i.dia_bloqueo > 0)
    if (filterArr.length) return filterArr.map((i: any) => i.dia_bloqueo.toString())
    else return []
}